const ImageProvider = [
  {
    logo_light: require("./images/2.png"),
    alt: "logo",
  },
  {
    logo_dark: require("./images/1.png"),
    alt: "logo",
  },
  {
    background_details: require('./images/177758142_c0c4e7b0-8b70-4f61-82e0-64f220610027.jpg'),
    alt_details: 'Image Details'
  },
  {
    welcome: require('./images/rb_2148817994.png'),
    alt: 'welcome'
  },
  {
    what: require('./images/rb_2150189560.png'),
    alt: 'what we used'
  },
  {
    mission: require('./images/rb_7874.png'),
    alt: 'mission'
  },
  {
    about: require('./images/rb_2148921809.png')
  },
  {
    favorites: require('./images/organic-flat-feedback-concept.png'),
    alt: 'favorites'
  },
  {
    isbn: require('./images/isbn.png'),
    alt: 'isbn'
  },
  {
    form_background: require('./images/nature-scene-rural-land-agriculture-grassland-abtract-silhouette-asian-farmers-working-rice-field-illustration.png'),
    alt: 'form_background'
  },
  {
    form_input_img: require('./images/placeholder-concept-illustration.png'),
    alt: 'form input'
  },
  {
    form_submit: require('./images/people-are-doing-online-chatting.png'),
    alt: 'form submit'
  }
];
export default ImageProvider;
